import { DashboardWidgetType } from 'features/dashboard/types'
import { InsightData } from 'schemas/action/InsightDataSchema'
import ScopedStringListVo from 'vo/ScopedStringList'
import Scope from 'enums/Scope'
import { WidgetSettingComposingStrategy } from './widgetSettingComposingStrategy'

const canBeDrilledDown = (widgetSetting: DashboardWidgetType) =>
  widgetSetting.includedTerms === undefined ||
  widgetSetting.includedTerms === null ||
  widgetSetting.includedTerms.length < 2

const isOverMaxInput = (applicationSettings: any) => (insights: InsightData[]) =>
  insights.length > applicationSettings.analysisMaxTerms

const composeAddedIncludedTerms = (insights: InsightData[]) => {
  const addedIncludedTerms = ScopedStringListVo()
  addedIncludedTerms.terms = Array.from(insights).flatMap((insight) => [
    insight.name || insight.stemmedForm,
    ...(insight.variants || [])
  ])
  addedIncludedTerms.scope = Scope.PARAGRAPH

  return addedIncludedTerms
}

const composeDrillDownWidgetSetting = (
  widgetSetting: DashboardWidgetType,
  insights: InsightData[]
) => ({
  ...widgetSetting,
  includedTerms: [...(widgetSetting.includedTerms || []), composeAddedIncludedTerms(insights)]
})

const generateIncludedTermsStrategy = (
  applicationSettings: any
): WidgetSettingComposingStrategy => ({
  canBeDrilledDown,
  isOverMaxInput: isOverMaxInput(applicationSettings),
  composeDrillDownWidgetSetting
})

export default generateIncludedTermsStrategy
